var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "var(--color-custom-icons-bg, #F5F3FF)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--inner-color, #5835FF)",
    d: "M11.62 13.7h1.2v-1.185l.69-.465c.825-.54 2.04-1.335 2.04-2.925 0-1.47-1.035-2.85-3.18-2.85-1.905 0-3.375 1.2-3.375 3.405h1.14c0-1.455.9-2.31 2.235-2.31 1.365 0 1.98.885 1.98 1.77 0 1.08-.63 1.5-1.47 2.085l-1.26.87zm-.03 3.3h1.275v-1.845H11.59z"
  })));
};
export default SvgQuestion;